module.exports = __webpack_public_path__ + "static/media/gameFavicon.921632d2.ico";